(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/selectors/assets/javascripts/invite-members.js') >= 0) return;  svs.modules.push('/components/marketplace-data/selectors/assets/javascripts/invite-members.js');
"use strict";


const selectInviteMembers = state => state.InviteMembers;
setGlobal('svs.components.marketplaceData.selectors.inviteMembers', {
  selectInviteMembers
});

 })(window);